export const iconFontAwesomeTransportationTruckFieldUn = (
	<i className="fa-solid fa-truck-field-un"></i>
);
